
















































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    dataCenter: { required },
  },
})
export default class ZtServerConfig extends SwExtendedVue {
  @Prop()
  showZtServerConfig: boolean;
  ttserverfqdn : string = '';
  ttserverurl : string = '';
  @Prop()
  ztServerObj : any;
  submitted: boolean = false;
  errorMessage: string = '';
  ttserverurlValidator : boolean = false;
  ttserverfqdnValidator : boolean = false;
  hostNameRegexValidator = new RegExp('^(?!.* .*)(?:[a-zA-Z0-9]{0,61}[a-zA-Z0-9][.:-])+[a-zA-Z0-9]{0,61}[a-zA-Z0-9]$');
  @Watch('ttserverurl')
  ttserverurlChange() {
    if (this.ttserverurl && !this.ttserverurl.match(this.hostNameRegexValidator)) {
      this.ttserverurlValidator = true;
    } else {
      this.ttserverurlValidator = false;
    }
  }
  @Watch('ttserverfqdn')
  ttserverfqdnChange() {
    if (this.ttserverfqdn && !this.ttserverfqdn.match(this.hostNameRegexValidator)) {
      this.ttserverfqdnValidator = true;
    } else {
      this.ttserverfqdnValidator = false;
    }
  }
  closeDialog() {
    this.$emit('closeZtServerDialog', false);
  }
  created() {
    console.warn(this.ztServerObj);
    this.ttserverurl  = this.ztServerObj.ttserverurl;
    this.ttserverfqdn  = this.ztServerObj.ttserverfqdn;
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    if ((this.ttserverurl !== '' && this.ttserverfqdn === '') ||
    (this.ttserverurl === '' && this.ttserverfqdn !== '')) {
      this.errorMessage = 'Field is mandatory';
    }
    if (this.errorMessage === '' && !this.ttserverurlValidator && !this.ttserverfqdnValidator) {
      const inner: any = {};
      inner['ttserverurl'] = this.ttserverurl;
      inner['ttserverfqdn'] = this.ttserverfqdn;
      this.$store
        .dispatch('MswProductsStoreModule/editttServer', {
          policyServerUrl: this.ttserverurl,
          ttServerFQDN : this.ttserverfqdn,
          serialNumber: this.ztServerObj.serialNumber,
          strMode: 'NSMONPREMCONFIG',
        })
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'OK') {
            // tslint:disable-next-line:max-line-length
            // this.$store.commit('MswProductsStoreModule/editProduct', { property: 'ztonpremttfqdnurl', with: this.ttServerEditedText === '' ? this.ttServerText : this.ttServerEditedText });
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
          }
          this.$emit('closeZtServerDialog', true);
        });
    }
  }
}
